export class Level {
  level: number;
  experience: number;
}
